export const blogData = [
  {
    id: 1,
    title: "TypeScript with React",
    description:
      "Examples and best practices about using typescript with a react application",
    date: "Juin 1, 2021",
    image: "https://miro.medium.com/max/700/1*c_otGxMhQQYeAODaylsf5A.png",
    url: "https://medium.com/@najd.feki/typescript-with-react-examples-and-best-practices-1580f2189103",
  },
  {
    id: 2,
    title: "React Server-Side Rendering",
    description: "How To create a Server-Side rendered react application.",
    date: "Aug 23, 2021",
    image: "https://miro.medium.com/max/700/1*rjzc6A5o7MSYql2ka7HgEQ.jpeg",
    url: "https://medium.com/@najd.feki/server-side-rendering-using-razzle-with-react-c62dc16e0631",
  },
];
